import { render, staticRenderFns } from "./InboxWindowHead.vue?vue&type=template&id=8d6a85e6"
import script from "./InboxWindowHead.vue?vue&type=script&lang=ts"
export * from "./InboxWindowHead.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8d6a85e6')) {
      api.createRecord('8d6a85e6', component.options)
    } else {
      api.reload('8d6a85e6', component.options)
    }
    module.hot.accept("./InboxWindowHead.vue?vue&type=template&id=8d6a85e6", function () {
      api.rerender('8d6a85e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inbox/InboxWindowHead.vue"
export default component.exports